import MuiCard, { CardProps as MuiCardProps } from '@mui/material/Card';

export type CardProps = MuiCardProps;

export const Card = (props: CardProps) => {
  return <MuiCard {...props} />;
};
